import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../../services/archismall.service';

class RiferimentoPAModalController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        'ArchiSmallServices',
        '$timeout',
        '$uibModalStack',
        '$sce',
        '$state'
    ];

    private close: any;
    private dismiss: any;

    constructor(
        private $scope: any,
        private $rootScope: any,
        private ArchiSmallServices: ArchiSmallServices,
        private $timeout: ng.ITimeoutService,
        private $uibModalStack: ng.ui.bootstrap.IModalStackService,
        private $sce: ng.ISCEService,
        private $state: ng.ui.IStateService
    ) {
        $scope.referenceValue = $scope.$parent.$resolve.referenceValue;
        $scope.option = $scope.$parent.$resolve.option;
        $scope.searchRiferimento = (referenceValue, option) => {
            $scope.specialFilter = {};
            $scope.specialFilter.user = $rootScope.user.accountData.email;
            $scope.specialFilter.sendingId = referenceValue;
            $scope.specialFilter.option = option;
            $scope.specialFilter.pageNumber = 1;
            $scope.specialFilter.pageSize = 10;
            $scope.getInvoices($scope.specialFilter);
        };

        $scope.getInvoices = (filter) => {
            ArchiSmallServices.getFatturazioneDocuments(filter, '_id', -1)
                .then((response: any) => {
                    let res = response;
                    if (res.Result === 1) {
                        $scope.invoices = res.resultList;
                    }
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };

        $scope.searchRiferimento($scope.$parent.$resolve.referenceValue, $scope.$parent.$resolve.option);
        $scope.ok = () => {
            $scope.save();
        };
        $scope.cancel = () => {
            this.dismiss({ $value: 'cancel' });
        };
        $scope.rectifyInvoice = (xmlpath) => {
            this.close();
            $state.go('home.componi-fattura', { xmlpath: xmlpath });
        };
        $scope.save = () => {
            this.close();
        };
    }
}

export const RiferimentoPAModalComponent: ng.IComponentOptions = {
    template: require('./riferimento-pa-modal.html'),
    controller: RiferimentoPAModalController,
    bindings: {
        close: '&',
        dismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/riferimento-pa-modal/riferimento-pa-modal.ts